import { displayFontFamily } from "styles/theme";

const ink = "#0E3A2A";
const ink2 = "#1F5040";
const inkMuted = "#6B7770";
const hairline = "#E5DCC8";
const bgPage = "#F7F4EE";
const bgCard = "#FFFFFF";
const bgCardTinted = "#F4F0E7";
const coral = "#E85D4E";
const coralHover = "#D24A3C";
const coralSoft = "#FCE8E4";
const coralInk = "#B7332A";
const coralBorder = "#F6CFCB";
const lilacSoft = "#EDE6FA";
const lilacBorder = "#DDD0F4";
const lilacInk = "#6F4FBF";
const lilacText = "#4B2E94";

const styles = {
  drawerPaper: {
    bgcolor: bgPage,
    width: { xs: "auto", md: 560 },
    maxWidth: { xs: "100vw", md: 560 },
    height: "100svh",
    overflow: "hidden",
  },
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    bgcolor: bgPage,
  },
  header: {
    px: 3,
    py: 2.25,
    borderBottom: `1px solid ${hairline}`,
    display: "flex",
    alignItems: "center",
    gap: 1.75,
    flexShrink: 0,
  },
  headerBadge: {
    width: 36,
    height: 36,
    borderRadius: "10px",
    bgcolor: coralSoft,
    color: coralInk,
    display: "grid",
    placeItems: "center",
    flexShrink: 0,
    fontSize: 15,
  },
  headerTitle: {
    fontFamily: displayFontFamily,
    fontSize: 20,
    fontWeight: 600,
    letterSpacing: "-0.3px",
    color: ink,
    mb: 1,
  },
  headerSub: {
    fontSize: 12.5,
    color: inkMuted,
  },
  closeBtn: {
    ml: "auto",
    width: 32,
    height: 32,
    borderRadius: "999px",
    color: inkMuted,
    "&:hover": { bgcolor: bgCardTinted, color: ink },
  },
  body: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    px: 3,
    pt: 2.5,
    pb: 2,
    display: "flex",
    flexDirection: "column",
    gap: 1.75,
  },
  contextCard: {
    bgcolor: bgCard,
    border: `1px solid ${hairline}`,
    borderRadius: "14px",
    p: "12px 14px",
    display: "flex",
    gap: 1.5,
    alignItems: "center",
  },
  avatar: {
    width: 32,
    height: 32,
    fontSize: 13,
    fontWeight: 700,
    bgcolor: coralSoft,
    color: coralInk,
    border: `1px solid ${coralBorder}`,
  },
  brandName: {
    fontWeight: 600,
    fontSize: 13.5,
    color: ink,
    lineHeight: 1.2,
  },
  contextMeta: {
    fontSize: 12,
    color: inkMuted,
    mt: "2px",
  },
  threadLink: {
    ml: "auto",
    fontSize: 12,
    color: ink2,
    fontWeight: 500,
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    textDecoration: "none",
    whiteSpace: "nowrap",
    cursor: "pointer",
    "&:hover": { textDecoration: "underline" },
  },
  aiTip: {
    bgcolor: lilacSoft,
    border: `1px solid ${lilacBorder}`,
    borderRadius: "14px",
    p: "12px 14px",
    display: "flex",
    gap: 1.25,
    alignItems: "flex-start",
    fontSize: 12.5,
    color: lilacText,
    "& strong": { fontWeight: 600 },
  },
  aiTipIcon: {
    width: 24,
    height: 24,
    borderRadius: "6px",
    bgcolor: "#fff",
    display: "grid",
    placeItems: "center",
    color: lilacInk,
    flexShrink: 0,
    fontSize: 12,
  },
  aiTipApply: {
    ml: "auto",
    bgcolor: lilacInk,
    color: "#fff",
    px: 1.25,
    py: 0.5,
    borderRadius: "999px",
    fontSize: 11.5,
    fontWeight: 600,
    flexShrink: 0,
    textTransform: "none",
    minWidth: 0,
    lineHeight: 1.4,
    "&:hover": { bgcolor: "#5d3fa8" },
  },
  mailCard: {
    bgcolor: bgCard,
    border: `1px solid ${hairline}`,
    borderRadius: "14px",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  progressContainer: {
    width: "100%",
    pt: 1,
  },
  footer: {
    px: 3,
    py: 1.75,
    borderTop: `1px solid ${hairline}`,
    bgcolor: bgCard,
    display: "flex",
    alignItems: "center",
    gap: 1.25,
    flexShrink: 0,
  },
  sendsNowPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.75,
    bgcolor: bgCardTinted,
    px: 1.5,
    py: 0.75,
    borderRadius: "999px",
    fontSize: 12,
    fontWeight: 500,
    color: ink2,
  },
  cancelBtn: {
    color: ink2,
    fontSize: 13,
    fontWeight: 500,
    textTransform: "none",
    borderRadius: "999px",
    px: 1.5,
    "&:hover": { bgcolor: bgCardTinted },
  },
  sendBtn: {
    bgcolor: coral,
    color: "#fff",
    textTransform: "none",
    fontWeight: 600,
    fontSize: 13,
    px: 2.25,
    py: 1,
    borderRadius: "999px 0 0 999px",
    boxShadow: "none",
    border: "none",
    "&:hover": { bgcolor: coralHover, boxShadow: "none" },
  },
  sendArrow: {
    bgcolor: coral,
    color: "#fff",
    borderRadius: "0 999px 999px 0",
    boxShadow: "none",
    borderLeft: `1px solid ${coralHover} !important`,
    "&:hover": { bgcolor: coralHover, boxShadow: "none" },
  },
} as const;

export default styles;
